import cx from 'classnames';
import React from 'react';

import { transformContentfulObject } from 'services/cms/transformers/contentful';
import type { AppType, WithCMS } from 'services/cms/typesUtil';
import { MODULE_MAP } from '../PageAssembly/ModuleWrapper/ModuleWrapper';
import styles from './ComponentAssembly.module.scss';

type ComponentAssemblyProps = AppType.Component<{
  headline: string;
  items: Array<WithCMS<AppType.Content>>;
}>;

export const ComponentAssembly: React.FC<ComponentAssemblyProps> = ({ headline, items, ...props }) => {
  const renderComponent = (item: WithCMS<AppType.Content>) => {
    const contentType = item._sys.contentType as string;
    const Component = MODULE_MAP[contentType];

    if (!Component) {
      console.error('[ComponentAssembly] Could not find component', contentType);
      return null;
    }

    if (!item._sys.id) {
      console.error('[ComponentAssembly] Unable to render component without ID', contentType, item);
      return null;
    }

    const componentProps = transformContentfulObject(item as any);
    return <Component key={item._sys.id} {...componentProps} />;
  };

  return (
    <section className={cx(styles.componentAssembly)} {...props._attributes}>
      <h2>{headline}</h2>
      <div className={styles.componentChildren}>
        {items?.map(item => renderComponent(item as WithCMS<AppType.Content>))}
      </div>
    </section>
  );
};
